import { memo } from 'react';

import { VFlex, VLoadingSpinner, cn } from '@/package';

import style from './style';

type TickerItemProps = {
  ticker: number;
  tickWidth: number;
  index: number;
  isFrameFileLoading: boolean;
  preloadedFrameSeqList: number[];
  lastPreloadedFrameSeq: number;
  isAssignedMeFrameSeq: (seq: number) => boolean;
  isBoundary: boolean;
  isInActiveRange: boolean;
  tickerOffset: number;
  tick: number;
  tickInterval: number;
  visibleOnlyMyFrame: boolean;
};

const TickerItem = memo(
  ({
    ticker,
    tickWidth,
    index,
    isFrameFileLoading,
    preloadedFrameSeqList,
    lastPreloadedFrameSeq,
    isAssignedMeFrameSeq,
    isBoundary,
    isInActiveRange,
    tickerOffset,
    tick,
    tickInterval,
    visibleOnlyMyFrame,
  }: TickerItemProps) => {
    const isPreloaded = preloadedFrameSeqList[ticker];
    const isAssignedMe = isAssignedMeFrameSeq(ticker);
    const isPrevPreloaded = preloadedFrameSeqList[ticker - 1];
    const isNextPreloaded = preloadedFrameSeqList[ticker + 1] != null;
    const isLastPreloaded = ticker === lastPreloadedFrameSeq;

    return (
      <VFlex
        className={cn(style.tickerListGroup, {
          [style.tickerListGroupPreloaded]:
            isInActiveRange &&
            isPreloaded &&
            !isLastPreloaded &&
            isNextPreloaded,
        })}
        style={{ '--width': `${tickWidth}px` } as React.CSSProperties}
        role="listitem"
      >
        <VFlex
          className={cn(style.tickerListGroupItem, {
            [style.tickerListGroupItemAssignedMe]: isAssignedMe,
            [style.tickerListGroupItemPreloaded]:
              isInActiveRange && isPreloaded,
            '!rounded-tl-none !rounded-bl-none': isPrevPreloaded,
            'rounded-full': isLastPreloaded || !isNextPreloaded,
          })}
          aria-label="ticker"
          data-ticker={ticker}
        >
          <div
            className={cn(style.tickerListGroupItemText, {
              [style.tickerListGroupItemTextEm]:
                !((ticker - tickerOffset) % tick) ||
                !((ticker - tickerOffset) % tickInterval),
              [style.tickerListGroupItemTextBoundary]: isBoundary,
              [style.tickerListGroupItemTextOuter]: !isInActiveRange,
              [style.tickerListGroupItemOtherText]:
                visibleOnlyMyFrame && !isAssignedMe,
            })}
            data-ticker={ticker}
          >
            {index === ticker - 1 && isFrameFileLoading ? (
              <VLoadingSpinner className="!size-4 text-status-inProgress" />
            ) : (
              ticker
            )}
          </div>
        </VFlex>
      </VFlex>
    );
  },
);

export default TickerItem;
